import { useQuery } from "@tanstack/react-query";
import { areIntervalsOverlapping, format, getYear } from "date-fns";
import { useMemo } from "react";
import { useCalendarProvider } from "../CalendarProvider";
import { holidayService } from "./holidayService";

export const useHolidays = () => {
	const state = useCalendarProvider();
	const { data: holidays = [] } = useQuery({
		queryKey: [
			...holidayService.holidaysKey(state.settings.yasumiProviderId, getYear(state.selectedDate)),
			state.settings.showHolidays,
		],
		queryFn: () =>
			holidayService.holidays(state.settings.yasumiProviderId, getYear(state.selectedDate)).then((r) => r.data.data),
		enabled: state.settings.showHolidays,
	});

	return useMemo(
		() =>
			holidays
				.map((x) => ({
					start: format(x.date, "yyyy-MM-dd"),
					end: format(x.date, "yyyy-MM-dd"),
					name: x.name,
					id: x.name,
				}))
				.filter((x) => areIntervalsOverlapping({ start: state.startOfMonthAndWeek, end: state.endOfMonthAndWeek }, x)),
		[state.endOfMonthAndWeek, holidays, state.startOfMonthAndWeek],
	);
};
